import "core-js/features/url";
import "core-js/features/url-search-params";
/*
 * @Author: chenchen
 * @Date: 2021-06-22 10:59:25
 * @LastEditTime: 2021-06-22 15:15:00
 * @LastEditors: chenchen
 * @Description: 处理SSO单点登入/登出逻辑
 */

export const LocalUrl =
  window.top.location.origin + window.top.location.pathname;
const ssoUrl = window.shield.ShieldConfig.braveCfg.customParams[0].SSO_URL;
/**
 * SSO登入，登入后会跳转到redirectPath，并带上ticket信息
 *
 * @param {string} ssoPath
 * @param {string} redirectPath
 */
export const ssoLogin = (ssoPath = ssoUrl, redirectPath = LocalUrl) => {
  window.top.location.replace(`${ssoPath}/login?service=${redirectPath}`);
};

/**
 * SSO登出，登出后会跳转到redirectPath，一般用在拿ticket请求token接口失败后调用
 *
 * @param {*} ssoPath
 * @param {*} redirectPath
 */
export const ssoLogout = (ssoPath = ssoUrl, redirectPath = LocalUrl) => {
  window.top.location.replace(`${ssoPath}/logout?service=${redirectPath}`);
};

/**
 * 从url里取ticket信息，一般用在页面初始化
 *
 * @returns ticket信息和redirectPath的数组，如果ticket不存在，会返回null.
 *
 * type = [ticket, redirectPath]
 */
export const ssoTicket = () => {
  const URLObj = new URL(window.location.href);
  const ticketString = URLObj.searchParams.get("ticket");
  URLObj.searchParams.delete("ticket");
  const redirectPath = URLObj.toString();
  return [ticketString, redirectPath];
};
